/** App 下载地址 */
export const APP_DOWNLOAD = {
  androidUrl: 'https://oss.harence.com/down/harence-jiazhuang.apk',
  iosUrl: '' // iOS 暂不开放
}

export function appDownloadPageUrl() {
  if (typeof window === 'undefined') return '/#/app-download'
  const origin = window.location.origin || ''
  const path = (window.location.pathname || '/').replace(/\/index\.html$/, '/')
  const base = (origin + path).replace(/\/?$/, '/')
  return base + '#/app-download'
}
